import * as TK from 'pages/EmailVerificationPage/translations/constants';
import { Translations } from 'translations/types';

export const emailVerificationPageEnUsLocale: Translations = {
  [TK.EMAIL_VERIFICATION_PAGE_TITLE]: 'Verify your Account',
  [TK.EMAIL_VERIFICATION_PAGE_VERIFICATION_DESCRIPTION]: 'To help protect from fraud and identity theft, and to comply with federal regulation, you need to verify your email.',
  [TK.EMAIL_VERIFICATION_PAGE_ICON_ALT]: 'identity icon',
};
